/* MOL Product Main — swipeable gallery (CSS scroll-snap) with thumbnail sync.
   Thumb click scrolls the stage to that slide; swiping the stage moves the
   is-active highlight to the matching thumb. Thumbs are optional (single-image
   products render none) — swipe is pure CSS, so the JS just bails out.
   Scoped to [data-mol-gallery]. */
(function () {
  function initGallery(gallery) {
    var stage = gallery.querySelector('[data-mol-gallery-stage]');
    var thumbs = gallery.querySelectorAll('[data-mol-gallery-thumb]');
    if (!stage || !thumbs.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollTimer;

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', Number(thumb.dataset.molIndex) === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        stage.scrollTo({
          left: Number(thumb.dataset.molIndex) * stage.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      });
    });

    stage.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setActiveThumb(Math.round(stage.scrollLeft / stage.clientWidth));
      }, 60);
    }, { passive: true });
  }

  document.querySelectorAll('[data-mol-gallery]').forEach(initGallery);
}());

/* MOL Product Main — add to cart wired into Focal's AJAX cart.
   Replicates Focal's ProductForm flow: POST to cartAddUrl (requesting the
   mini-cart section), then dispatch cart:refresh + cart-notification:show on
   <html> so Focal's <cart-drawer>/<cart-notification>/<cart-count> respond.
   Falls back to a normal form POST if Focal's globals aren't present. */
(function () {
  function initAtc(form) {
    form.addEventListener('submit', function (event) {
      var tv = window.themeVariables;
      if (!tv || !tv.routes || !tv.routes.cartAddUrl) {
        return; // no Focal cart on page — let the form POST normally
      }
      event.preventDefault();

      var btn = form.querySelector('.mol-atc__btn');
      var data = new FormData(form);
      if (!data.get('quantity')) {
        data.set('quantity', 1);
      }
      data.set('sections', 'mini-cart');

      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }

      fetch(tv.routes.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
              bubbles: true,
              cancelable: true,
              detail: { status: 'error', error: (result.json && result.json.description) || '' }
            }));
            return;
          }
          return fetch(tv.routes.cartUrl + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = result.json.sections;
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cart,
                  openMiniCart: tv.settings && tv.settings.cartType === 'drawer'
                }
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
                bubbles: true,
                cancelable: true,
                detail: { status: 'success', error: '' }
              }));
            });
        })
        .catch(function () {
          form.submit(); // network failure — fall back to a full page add
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    });
  }

  document.querySelectorAll('.mol-product-main .mol-atc form').forEach(initAtc);
}());

/* MOL Product Main — directional circle-reveal hover on the add-to-cart button.
   The fill circle's origin tracks the cursor, so the wash appears to flow in
   from the direction you enter and drain out toward where you leave.
   Scoped to [data-mol-btn-hover]; sold-out (disabled) buttons get no listeners. */
(function () {
  function handleHover(event) {
    var btn = event.currentTarget;
    var rect = btn.getBoundingClientRect();
    var circle = btn.querySelector('.mol-atc__circle');
    if (!circle || !rect.width) return;

    // Centre the circle on the cursor's entry/exit point.
    var xPct = ((event.clientX - rect.left) / rect.width) * 100;
    var yPct = ((event.clientY - rect.top) / rect.height) * 100;

    // The further from centre you enter, the wider the circle must be to still
    // cover the far edge of the button.
    var offsetFromCenter = Math.abs(
      ((event.clientX - (rect.left + rect.width / 2)) / (rect.width / 2)) * 50
    );

    circle.style.left = xPct.toFixed(1) + '%';
    circle.style.top = yPct.toFixed(1) + '%';
    circle.style.width = (115 + offsetFromCenter * 2).toFixed(1) + '%';
  }

  document.querySelectorAll('.mol-product-main [data-mol-btn-hover]').forEach(function (btn) {
    if (btn.disabled) return; // sold out — no animation, no listeners
    btn.addEventListener('mouseenter', handleHover); // fill in from entry point
    btn.addEventListener('mouseleave', handleHover); // drain toward exit point
  });
}());
